import { Navigation, StringUtil, UrlUtil } from "@mcleod/core";
import { AutogenLayoutCarrierDriverMessage } from "./autogen/AutogenLayoutCarrierDriverMessage";
import { CarrierDriverMessageTaskFilterType } from "@mcleod/powerbroker";

const layoutURL = "lme/powerbroker/CarrierDriverMessage";

export class CarrierDriverMessage extends AutogenLayoutCarrierDriverMessage {
    public static navigateTo(taskFilter?: CarrierDriverMessageTaskFilterType): void {
        Navigation.navigateTo(
            layoutURL + (taskFilter ? `?taskFilter=${taskFilter}` : "")
        );
    }

    onLoad(): void | Promise<void> {
        const taskFilter = UrlUtil.getSearchParamFromUrl("taskFilter");
        if(taskFilter){
            this.textboxDateRange.clear();
            this.mainDataSource.search();
            if(!StringUtil.equalsIgnoreCase(taskFilter, CarrierDriverMessageTaskFilterType.ALL)) {
                const filterPanel = this.layoutCarrierDriverMessageTable.filterPanel;
                filterPanel.toggleFilterById(taskFilter);
            }
        }
    }
}


